import {
  SETTLEMENT_DETAILS_SUCCESS,
  SETTLEMENT_DETAILS_FAILED,
  RESET_SETTLEMENT_DETAILS,
  LOADING_SETTLEMENT_DETAILS,
  NETWORK_ERROR_SETTLEMENT_DETAILS,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SETTLEMENT_DETAILS: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case SETTLEMENT_DETAILS_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case SETTLEMENT_DETAILS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_SETTLEMENT_DETAILS: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        networkError: true,
        data: {},
      };
    }
    case RESET_SETTLEMENT_DETAILS: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
